import { BaseProps, Button, ForwardProps, defaultThemeProp } from '@pega/cosmos-react-core';
import React from 'react';
import { forwardRef, FunctionComponent, PropsWithoutRef, Ref } from 'react';
import styled, { css } from 'styled-components';
import Dialog, { StyledDialog, useDialog } from './Dialog';
import HTML from './HTML';
import useLocalTranslation from '../../hooks/useLocalTranslation';

export interface AdditionalInfoProps extends BaseProps {
  heading: string;
  children: string | JSX.Element;
  ref?: Ref<HTMLDivElement>;
}

export const StyledAdditionalInfo = styled.div(
  () => css`
    & > ${StyledDialog} {
      max-width: 45vw;
    }
  `,
);

StyledAdditionalInfo.defaultProps = defaultThemeProp;

const AdditionalInfo: FunctionComponent<AdditionalInfoProps & ForwardProps> = forwardRef(
  ({ heading, children, ...restProps }: PropsWithoutRef<AdditionalInfoProps>, ref: AdditionalInfoProps['ref']) => {
    const { target, events } = useDialog();
    const translate = useLocalTranslation();

    return (
      <StyledAdditionalInfo ref={ref} {...restProps}>
        <Button variant="simple" label={translate('additional_info')} compact icon {...events}>
          {/* Adding svg directly here as <Icon name="information" /> is not displaying updated style, due to older version of cosmos-core.
          Once it is on or beyond version 4.0.0 we can remove this and use Icon component.
          */}
          <svg role="presentation" viewBox="0 0 25 25" style={{ width: '18px', height: '18px' }}>
            <path d="M4.37 20.63C2.122 18.386 1 15.69 1 12.5c0-3.19 1.123-5.885 3.37-8.13C6.614 2.122 9.31 1 12.5 1c3.19 0 5.885 1.123 8.13 3.37C22.878 6.614 24 9.31 24 12.5c0 3.19-1.123 5.885-3.37 8.13C18.386 22.878 15.69 24 12.5 24c-3.19 0-5.885-1.123-8.13-3.37Zm-2.49-8.182c0 2.15.582 4.12 1.791 5.866 1.164 1.79 2.73 3.09 4.701 3.94 1.971.851 4.03 1.03 6.134.627s3.895-1.388 5.418-2.91c1.478-1.478 2.463-3.314 2.91-5.418.404-2.105.224-4.12-.626-6.09-.806-1.97-2.104-3.537-3.85-4.745-1.792-1.21-3.761-1.791-5.91-1.791-2.911 0-5.373 1.03-7.433 3.045-2.06 2.06-3.09 4.567-3.134 7.477ZM13.65 5.14c.843 0 1.61.69 1.61 1.61 0 .92-.69 1.61-1.61 1.61-.843 0-1.61-.69-1.61-1.61 0-.92.69-1.61 1.61-1.61ZM12.1 19.4c-1.263 0-2.175-1.04-1.824-2.274l1.5-4.36c.14-.51.359-1.437-.132-1.437-.328 0-.728.164-1.201.491.35-1.09 1.333-1.62 2.456-1.62 1.264 0 2.176 1.04 1.825 2.274l-1.5 4.36c-.14.51-.17 1.338.322 1.338.328 0 .665-.13 1.011-.392-.35 1.09-1.333 1.62-2.456 1.62Z"></path>
          </svg>
        </Button>
        <Dialog heading={heading} target={target}>
          {typeof children === 'string' ? <HTML content={children} /> : children}
        </Dialog>
      </StyledAdditionalInfo>
    );
  },
);

export default AdditionalInfo;
